export enum COUNTRY_CODE {
  MEXICO = 'MX',
  USA = 'US',
  UNITED_KINGDOM = 'GB',
  GERMANY = 'DE',
  FRANCE = 'FR',
  COLOMBIA = 'CO',
  COSTA_RICA = 'CR',
  NICARAGUA = 'NI',
  PANAMA = 'PA',
  EL_SALVADOR = 'SV',
  ISRAEL = 'IL',
  SPAIN = 'ES',
  DOMINICAN_REPUBLIC = 'DO',
  PUERTO_RICO = 'PR',
  GUATEMALA = 'GT',
  PERU = 'PE',
  PHILIPPINES = 'PH',
  POLAND = 'PL',
  CZECH_REPUBLIC = 'CZ',
  UNITED_ARAB_EMIRATES = 'AE',
  EGYPT = 'EG',
  LATVIA = 'LV',
  CROATIA = 'HR',
  BOSNIA_AND_HERZEGOVINA = 'BA',
}

export type CountryCodesType =
  | COUNTRY_CODE.MEXICO
  | COUNTRY_CODE.USA
  | COUNTRY_CODE.UNITED_KINGDOM
  | COUNTRY_CODE.GERMANY
  | COUNTRY_CODE.FRANCE
  | COUNTRY_CODE.COLOMBIA
  | COUNTRY_CODE.COSTA_RICA
  | COUNTRY_CODE.NICARAGUA
  | COUNTRY_CODE.PANAMA
  | COUNTRY_CODE.EL_SALVADOR
  | COUNTRY_CODE.ISRAEL
  | COUNTRY_CODE.SPAIN
  | COUNTRY_CODE.DOMINICAN_REPUBLIC
  | COUNTRY_CODE.PUERTO_RICO
  | COUNTRY_CODE.GUATEMALA
  | COUNTRY_CODE.PERU
  | COUNTRY_CODE.POLAND
  | COUNTRY_CODE.PERU
  | COUNTRY_CODE.PHILIPPINES
  | COUNTRY_CODE.CZECH_REPUBLIC
  | COUNTRY_CODE.UNITED_ARAB_EMIRATES
  | COUNTRY_CODE.EGYPT
  | COUNTRY_CODE.LATVIA
  | COUNTRY_CODE.CROATIA
  | COUNTRY_CODE.BOSNIA_AND_HERZEGOVINA;
